export const CORRECTIVE_ACTIONS_COUNT_LOAD_SUCCESS =
  "CORRECTIVE_ACTIONS_COUNT_LOAD_SUCCESS";
